export const resize = 'resize';